import React, { useState } from 'react';
import { ICON_OPTIONS, getIcon } from '../../lib/icons';
import { ChevronDown } from 'lucide-react';

const IconPicker = ({ value, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const Selected = getIcon(value);

  return (
    <div className="relative">
      <button
        type="button"
        data-testid={testId}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 px-3 py-2 rounded-xl border border-stone-200 bg-white hover:border-emerald-400 transition-colors"
      >
        <Selected className="w-5 h-5 text-emerald-700" />
        <span className="text-sm font-body text-text-secondary">{value}</span>
        <ChevronDown className="w-4 h-4 text-stone-400" />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-20" onClick={() => setOpen(false)} />
          <div className="absolute z-30 mt-2 w-64 max-h-56 overflow-y-auto bg-white rounded-2xl border border-stone-200 shadow-xl p-3 grid grid-cols-6 gap-2">
            {ICON_OPTIONS.map((name) => {
              const Icon = getIcon(name);
              const active = name === value;
              return (
                <button
                  key={name}
                  type="button"
                  data-testid={`icon-option-${name}`}
                  onClick={() => {
                    onChange(name);
                    setOpen(false);
                  }}
                  title={name}
                  className={`flex items-center justify-center w-9 h-9 rounded-lg transition-colors ${
                    active ? 'bg-emerald-600 text-white' : 'hover:bg-emerald-50 text-stone-600'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default IconPicker;
